import { ReactNode, useId } from 'react';
import { useTranslation } from 'react-i18next';

import useRouteStore from '../../store/routeStore/useRouteStore';
import { locator } from '../../testing/e2e-locator/locator';
import { Button } from '../Button/Button';
import { Dialog } from '../Dialog/Dialog';

export const ApplicationUpdatedModal = (): ReactNode => {
  const { t } = useTranslation();
  const titleId = useId();
  const { reloadPage } = useRouteStore();

  const reloadPageClicked = (): void => {
    reloadPage();
  };

  return (
    <Dialog
      labelledBy={titleId}
      testId={locator.components.applicationUpdateModal.root}
    >
      <header
        data-testid={locator.components.applicationUpdateModal.header.root}
      >
        <h1
          data-testid={locator.components.applicationUpdateModal.header.h1}
          id={titleId}
        >
          {t('applicationUpdatedModal.title')}
        </h1>
      </header>
      <div>
        <main data-testid={locator.components.applicationUpdateModal.main.root}>
          <p data-testid={locator.components.applicationUpdateModal.main.p}>
            {t('applicationUpdatedModal.content')}
          </p>
        </main>
        <footer
          data-testid={locator.components.applicationUpdateModal.footer.root}
        >
          <Button
            data-testid={
              locator.components.applicationUpdateModal.footer.reloadPageButton
            }
            onClick={reloadPageClicked}
          >
            {t('applicationUpdatedModal.reloadPage')}
          </Button>
        </footer>
      </div>
    </Dialog>
  );
};
